import { render, staticRenderFns } from "./repayment.vue?vue&type=template&id=234e90d6&scoped=true"
import script from "./repayment.vue?vue&type=script&lang=js"
export * from "./repayment.vue?vue&type=script&lang=js"
import style0 from "./repayment.vue?vue&type=style&index=0&id=234e90d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "234e90d6",
  null
  
)

export default component.exports